import React, { useCallback, useContext } from 'react'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import AccountAccessModal from 'components/Account/AccountAccess/AccountAccessModal'
import type { AccountAccessModalResult } from 'components/Account/AccountAccess/AccountAccessModal.types'
import ModalContext from 'contexts/ModalContext'
import purchaseLuxPlus from 'actions/luxPlus/purchaseLuxPlus'
import LuxPlusFreePreviewModal from 'luxPlus/components/modals/LuxPlusFreePreviewModal'
import { selectLoggedIn } from 'selectors/accountSelectors'

function useLuxPlusLandingActions() {
  const dispatch = useAppDispatch()
  const showModal = useContext(ModalContext)
  const isLoggedIn = useAppSelector(selectLoggedIn)

  const handleBecomeMember = useCallback(async() => {
    if (isLoggedIn) {
      dispatch(purchaseLuxPlus({ hasJoinFee: true }))
      return
    }
    const result = await showModal<AccountAccessModalResult>(<AccountAccessModal />)
    if (result?.loggedIn) {
      dispatch(purchaseLuxPlus({ hasJoinFee: true }))
    }
  }, [showModal, dispatch, isLoggedIn])

  const handleStartFreePreview = useCallback(() => {
    showModal(<LuxPlusFreePreviewModal />)
  }, [showModal])

  return {
    handleBecomeMember,
    handleStartFreePreview,
  }
}

export default useLuxPlusLandingActions
